<template>
  <div class="search-container">
    <h1>Ricerca Codice in Assistenza Tecnica</h1>

    <div class="code-search">
      <label for="code">Inserisci codice:</label>
      <input
        type="text"
        id="code"
        v-model="searchCode"
        placeholder="es. 123456"
      />
      <button @click="searchByCode" :disabled="isLoading || !searchCode.trim()">
        Cerca
      </button>
    </div>

    <div v-if="isLoading" class="loader">
      <p>Cerco documenti…</p>
    </div>

    <p v-else-if="!isLoading && searched && !results.length">
      Nessun risultato per “{{ searchCode.trim() }}”
    </p>
    <p v-else-if="!isLoading && results.length">
      Risultati trovati: <strong>{{ results.length }}</strong>
    </p>

    <table v-if="results.length && !isLoading">
      <thead>
        <tr>
          <th>Doc ID</th>
          <th>idTicket</th>
          <th>operatorId</th>
          <th>status</th>
          <th>title</th>
          <th>ticketUserId</th>
          <th>conv Timestamp</th>
          <th>tipo</th>
          <th>conv User ID</th>
          <th>conv Email</th>
          <th>conv Nome</th>
          <th>content</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(r,i) in results" :key="i">
          <td>{{ r.docId }}</td>
          <td>{{ r.idTicket }}</td>
          <td>{{ r.operatorId }}</td>
          <td>{{ r.status }}</td>
          <td>{{ r.title }}</td>
          <td>{{ r.ticketUserId }}</td>
          <td>{{ r.timestamp }}</td>
          <td>{{ r.type }}</td>
          <td>{{ r.convUserId }}</td>
          <td>{{ r.convEmail || 'N/D' }}</td>
          <td>{{ r.convName || 'N/D' }}</td>
          <td>{{ r.content }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  getDocs,
  doc as docRef,
  getDoc
} from "firebase/firestore";

export default {
  name: "SearchAssistenzatecnicaByCode",
  data() {
    return {
      searchCode: "",
      isLoading: false,
      results: [],
      searched: false
    };
  },
  methods: {
    async searchByCode() {
      const code = this.searchCode.trim();
      if (!code) return;

      this.isLoading = true;
      this.results = [];
      this.searched = false;

      try {
        const db = getFirestore();
        const snap = await getDocs(collection(db, "assistenzatecnica"));
        console.log("Trovati doc:", snap.size);

        for (const docSnap of snap.docs) {
          const docData = { id: docSnap.id, ...docSnap.data() };

          if (!Array.isArray(docData.conversations)) continue;
          for (const conv of docData.conversations) {
            // debug
            console.log("→ conv.content:", conv.content);
            if (
              typeof conv.content === "string" &&
              conv.content.includes(code)
            ) {
              // prendi info utente conversazione
              let convEmail = "";
              let convName = "";
              if (conv.userId) {
                const uSnap = await getDoc(docRef(db, "users", conv.userId));
                if (uSnap.exists()) {
                  convEmail = uSnap.data().email || "";
                  convName  = uSnap.data().name  || "";
                }
              }

              // formatta timestamp
              let ts = conv.timestamp;
              if (ts?.toDate) ts = ts.toDate().toLocaleString();
              else ts = new Date(ts).toLocaleString();

              this.results.push({
                docId:       docData.id,
                idTicket:    docData.idTicket   || "N/D",
                operatorId:  docData.operatorId || "N/D",
                status:      docData.status     || "N/D",
                title:       docData.title      || "N/D",
                ticketUserId:docData.userId     || "N/D",
                timestamp:   ts,
                type:        conv.type          || "N/D",
                convUserId:  conv.userId        || "N/D",
                convEmail,
                convName,
                content:     conv.content
              });
            }
          }
        }

      } catch (e) {
        console.error("Errore in searchByCode:", e);
        alert("Errore, vedi console.");
      } finally {
        this.isLoading = false;
        this.searched = true;
      }
    }
  }
};
</script>

<style scoped>
.search-container { margin: 20px; }
.code-search {
  display: flex; align-items: center; gap: 10px; margin-bottom: 20px;
}
.loader { font-weight: bold; margin: 20px 0; }
table {
  width: 100%; border-collapse: collapse; margin-top: 10px;
}
th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
th { background: #f1f1f1; }
</style>
